/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Section_Ai_ModelsInputs */



/**
* | output |
* | --- |
* | "AI Models" |
*
* @param {Ad_Section_Ai_ModelsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_section_ai_models = /** @type {((inputs?: Ad_Section_Ai_ModelsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Section_Ai_ModelsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modèles d'IA")
	if (locale === "de") return /** @type {LocalizedString} */ ("KI-Modelle")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modelli di intelligenza artificiale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Модели искусственного интеллекта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Modelos de IA")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("人工智能模型")
	if (locale === "ja") return /** @type {LocalizedString} */ ("AIモデル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एआई मॉडल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Modelos de IA")
	return /** @type {LocalizedString} */ ("AI Models")
});